var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"d-flex background-color radius-4 mt-2",class:{
      'flex-column align-start': _vm.reuseIsMobile,
      'align-center justify-space-between': !_vm.reuseIsMobile,
    }},[_c('span',{staticClass:"font_30"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',[_c('span',{staticClass:"font_22"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('span',{staticClass:"font-11-no-000-18"},[_vm._v(" "+_vm._s(_vm.currencyName)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }